<template>
  <div class="view-container">
    <!-- TODO content för URL -->
    <HeroSection :imageUrl="$tc('startView.hero.image.url')">
      <template v-slot:normal>{{ $tc("startView.hero.heading", 1) }}</template>
      <template v-slot:bold>{{ $tc("startView.hero.heading", 2) }}</template>
    </HeroSection>
    <div style="flex: 1">
      <ContentContainer>
        <p class="big-paragraph">{{ $t("startView.description") }}</p>
        <router-link :to="{ name: 'CalculateView', params: { startQuery: this.$route.query } }">
          <CtaButton>
            {{ $t("startView.cta") }}
            <span>&#10141;</span>
          </CtaButton>
        </router-link>
      </ContentContainer>
    </div>
  </div>
</template>

<script>
import HeroSection from "../components/HeroSection";
import CtaButton from "../components/form/CtaButton";
import ContentContainer from "../components/ContentContainer";

export default {
  name: "StartView",
  components: { HeroSection, CtaButton, ContentContainer }
};
</script>

<style scoped lang="scss">
@media (min-width: $large) {
  .view-container {
    display: flex;
    align-items: center;
  }
}

.view-container {
  margin: 0 auto;
}

.paragraph-text {
  margin: 30px 0px;
  font-size: 18px;
  line-height: 1.5;
}
</style>
